import { NumberAsString } from "@/models/api";

export function toLiter(
	bottleContent: NumberAsString,
	suffix: boolean
): string | number {
	const val = parseInt(bottleContent, 10) / 1000;

	if (suffix) {
		return `${val} liter`;
	}

	return val;
}
